import { AuthService } from '@app/services';
import { Paginator } from '@app/classes';
import { Survey } from '@models/performance/survey.model';
import { Table } from '@app/modules/table/classes/table.class';
import {
    TitleColumn,
    CreatorColumn,
    DueDateColumn,
    StatusColumn,
} from '@performance/services/tables/survey-table/columns';

export class SurveyIndexTable extends Table {
    links = true;

    constructor(
        protected auth: AuthService,
        private employeeID: number
    ) {
        super(auth);
        this.boot();
    }

    getLink(survey: Survey): (string | number)[] {
        return ['/surveys', 'center', survey.id];
    }

    setColumns(): void {
        this.addColumns(new CreatorColumn(), new TitleColumn(), new DueDateColumn(), new StatusColumn());
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Survey.param('company', this.auth.company.id)
                .where('employeeId', this.employeeID)
                .with(['assignments', 'assignments.employee', 'creator'])
        );
    }
}
